import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { AccountOfficerService } from 'app/core/service/account-officer.service';
import { Observable, startWith, switchMap, map, catchError, of } from 'rxjs';
import * as accountOfficerActions from './account-officer.actions';

@Injectable()
export class AccountOfficerEffects {
  constructor(
    private _actions$: Actions,
    private _accofficerService: AccountOfficerService,
  ) {}

  loadAccountOfficers$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType<accountOfficerActions.LoadAccountOfficers>(
        accountOfficerActions.AccountOfficerActionTypes.LoadAccountOfficers,
      ),
      switchMap(() =>
        this._accofficerService.getAccountOfficers().pipe(
          map(items => new accountOfficerActions.LoadAccountOfficersSuccess(items)),
          catchError(error =>
            of(new accountOfficerActions.LoadAccountOfficersFail(error)),
          ),
        ),
      ),
    ),
  );
}
